import Logger from './logging';
import * as helpers from './helpers';
import { formatGender, isNumber, isValidAge } from './utils';
import { setPersistentValue } from "../functions/persistent";
import settings from '../libs/config';

const crypto = require('crypto');
const { createHash } = require('crypto');

const PARTNER_KEY = "pil_partnerkey";
const PARTNER_ID = "pil_partnerid";
export const REELCHAT_USERNAME = "ReelChatUserName";

export const isTester = (params) => {
	return params && params.test && parseInt(params.test) === 1;
};

export const isResumeEnabled = (params) => {
	return !isTester(params) || (params && params.resume && parseInt(params.resume) === 1);
};

export const partnerIdReplace = (params) => {
	let regex = new RegExp('responseid', 'g');
	/*
		partnerid_param is a parameter set in the group object 'redirects'
		If a provider uses a unique parameter for their partnerid values, we'll use the `partnerid_param` param to identify the key name
		and use it to set our partnerid key

		`pil_partnerid`, `pil_partner_id`, `partnerid` and `partner_id` can all be used to set our custom partnerid value in the 
		targerParams object in redux
	*/ 
	let partnerid = params.partnerid_param && params[params.partnerid_param]
		? params[params.partnerid_param]
		: params.pil_partnerid || params.pil_partner_id || params.partnerid || params.partner_id;
		
	Logger.log("targetProcess.js", 'partnerIdReplace()', params, partnerid);
	
	if (params.useridLabel && params[params.useridLabel]) {
		regex = new RegExp(params.useridLabel, 'g');
		partnerid = params[params.useridLabel];
	}

	params.partnerid = partnerid;

	const partner = params.partner.toLowerCase();

	switch (partner) {
		case 'toluna': {
			let tolunaid = params.tolunaid;
			
			if (!tolunaid && partnerid) {
				tolunaid = partnerid;
			}

			setPersistentValue(PARTNER_KEY, 'tolunaid', 1, true);
			setPersistentValue(PARTNER_ID, tolunaid, 1, true);

			regex = new RegExp('responseid', 'g');

			params.redir = params.redir ? params.redir.replace(regex, tolunaid) : null;
			params.err = params.err ? params.err.replace(regex, tolunaid) : null;
			params.dq = params.dq ? params.dq.replace(regex, tolunaid) : null;
			params.oq = params.oq ? params.oq.replace(regex, tolunaid) : null;
			params.partner = 'Toluna';
			return params;
		}
		case 'gmi': {
			/* Unique Partner Id */
			let url = decodeURIComponent(params.redir);
			let urlComps = url.split('?');
			let newParams = urlComps[1] ? urlComps[1].split('&') : null;

			let unique_id = newParams && newParams[0] ? newParams[0].split('=')[1] : null;
			if (!unique_id && partnerid) {
				unique_id = partnerid;
			}

			params.unique_id = unique_id;
			params.partner = 'GMI';
			return params;
		}
		case 'purespectrum': {
			let transaction_id = params.old_transaction_id ? params.old_transaction_id : params.transaction_id;

			if (!transaction_id && partnerid) {
				transaction_id = partnerid;
			}

			setPersistentValue(PARTNER_KEY, 'transaction_id', 1, true);
			setPersistentValue(PARTNER_ID, transaction_id, 1, true);

			params.redir = params.redir ? hashPureSpectrumPartnerUrl(params.redir.replace(regex, transaction_id)) : null;
			params.err = params.err ? hashPureSpectrumPartnerUrl(params.err.replace(regex, transaction_id)) : null;
			params.dq = params.dq ? hashPureSpectrumPartnerUrl(params.dq.replace(regex, transaction_id)) : null;
			params.oq = params.oq ? hashPureSpectrumPartnerUrl(params.oq.replace(regex, transaction_id)) : null;
			params.partner = 'PureSpectrum';
			return params;
		}
		case 'researchnow': {
			let rnowid = params.rnowid;

			if (!rnowid && partnerid) {
				rnowid = partnerid;
			}

			setPersistentValue(PARTNER_KEY, 'rnowid', 1, true);
			setPersistentValue(PARTNER_ID, rnowid, 1, true);

			regex = new RegExp('rnid_value', 'g');

			params.redir = params.redir ? params.redir.replace(regex, rnowid) : null;
			params.err = params.err ? params.err.replace(regex, rnowid) : null;
			params.dq = params.dq ? params.dq.replace(regex, rnowid) : null;
			params.oq = params.oq ? params.oq.replace(regex, rnowid) : null;
			params.partner = 'ResearchNow';
			return params;
		}
		case 'fuelcycle': {
			// before 
			// "https://portal.pilot.ly/process-target?
			// fcUserId=507762
			// &fcTrackId=46
			// &redirectUrl=https%3A%2F%2Femu.fuelcyclestage.com%2FexternalStudyRedirect%3FfcTrackId%3D46%&sec=1
			// &gid=798789543486786754344357
			// &partner=fuelcycle "

			// after 
			// "https://portal.pilot.ly/process-target?
			// fcUserId=507762
			// &fcTrackId=46
			// &redir=https%3A%2F%2Femu.fuelcyclestage.com%2FexternalStudyRedirect%3FfcTrackId%3D46%3FSTATUS%3DCOMPLETE
			// &err=https%3A%2F%2Femu.fuelcyclestage.com%2FexternalStudyRedirect%3FfcTrackId%3D46%3FSTATUS%3DTERMINATED
			// &oq=https%3A%2F%2Femu.fuelcyclestage.com%2FexternalStudyRedirect%3FfcTrackId%3D46%3FSTATUS%3DFAILED_OVER_QUOTA 
			// &sec=1&gid=798789543486786754344357
			// &partner=fuelcycle"
			params.partner = 'FuelCycle';
			params.redir = params.redirectUrl + encodeURIComponent("&participationstatus=COMPLETED");
			params.err = params.redirectUrl + encodeURIComponent("&participationstatus=TERMINATED");
			params.oq = params.redirectUrl + encodeURIComponent("&participationstatus=FAILED_OVER_QUOTA");
			params.dq = params.redirectUrl + encodeURIComponent("&participationstatus=FAILED_DATA_QUALITY");
			return params;
		}
		case 'focusinsite': {
			params.partner = "focusinsite";
			params.partnerName = "Focus Insite";
			return params;
		}
		case 'alida': {
			let member_id = params['MemberId'];
			let communication_id = params['CommunicationId'];
			let regexCommunicationId = new RegExp('communication_id', 'g');
			let regexMemberId = new RegExp('member_id', 'g');

			params.redir = params.redir ? params.redir.replace(regexCommunicationId, communication_id) : null;
			params.err = params.err ? params.err.replace(regexCommunicationId, communication_id) : null;
			params.dq = params.dq ? params.dq.replace(regexCommunicationId, communication_id) : null;
			params.oq = params.oq ? params.oq.replace(regexCommunicationId, communication_id) : null;

			params.redir = params.redir ? params.redir.replace(regexMemberId, member_id) : null;
			params.err = params.err ? params.err.replace(regexMemberId, member_id) : null;
			params.dq = params.dq ? params.dq.replace(regexMemberId, member_id) : null;
			params.oq = params.oq ? params.oq.replace(regexMemberId, member_id) : null;

			params.partnerid = member_id;
			return params;	
		}
		case 'qualtrics': {
			let completeUrl = null;
			let terminateUrl = null;

			let memberId = params['memberId'];
			if (!memberId && partnerid) {
				memberId = partnerid;
			}
			
			if (params['redirect-link']) {
				const redirectUrl = decodeURIComponent(params['redirect-link']);
				const redirectUrlWithParams = new URL(redirectUrl);
				redirectUrlWithParams.searchParams.set('event', 'complete');
				redirectUrlWithParams.searchParams.set('memberId', memberId);
				completeUrl = redirectUrlWithParams.toString();
				redirectUrlWithParams.searchParams.set('event', 'disqualified');
				terminateUrl = redirectUrlWithParams.toString();
			}
			
			params.redir = completeUrl;
			params.err = terminateUrl;
			params.dq = terminateUrl;
			params.oq = terminateUrl;

			params.partnerid = memberId;
			return params;
		}
		case 'material': {
			let engine_id = params['I.Engine'];
			let session_id = params['I.Session'];

			let regexIEngine = new RegExp('engine_id', 'g');
			let regexISession = new RegExp('session_id', 'g');

			params.redir = params.redir ? params.redir.replace(regexIEngine, engine_id) : null;
			params.err = params.err ? params.err.replace(regexIEngine, engine_id) : null;
			params.dq = params.dq ? params.dq.replace(regexIEngine, engine_id) : null;
			params.oq = params.oq ? params.oq.replace(regexIEngine, engine_id) : null;

			params.redir = params.redir ? params.redir.replace(regexISession, session_id) : null;
			params.err = params.err ? params.err.replace(regexISession, session_id) : null;
			params.dq = params.dq ? params.dq.replace(regexISession, session_id) : null;
			params.oq = params.oq ? params.oq.replace(regexISession, session_id) : null;
			return params;
		}
		case 'prodege': {
			let transaction_id = params.transaction_id;

			if (!transaction_id && partnerid) {
				transaction_id = partnerid;
			}

			setPersistentValue(PARTNER_KEY, 'transaction_id', 1, true);
			setPersistentValue(PARTNER_ID, transaction_id, 1, true);

			const secret_key = settings.prodegeKeys.secret_key;
			const apik = settings.prodegeKeys.apik;
			const byk = settings.prodegeKeys.byk;
			const stringToSign = `${secret_key}:apik=${apik}:byk=${byk}`;

			const decodedRedirects = decodeRedirects(params);
			const completeParams = parseUrl(decodedRedirects.redir);
			const completionValue = completeParams.completion_type;
			const errParams = parseUrl(decodedRedirects.err);
			const errValue = errParams.completion_type;
			const dqParams = parseUrl(decodedRedirects.dq);
			const dqValue = dqParams.completion_type;
			const oqParams = parseUrl(decodedRedirects.oq);
			const oqValue = oqParams.completion_type;

			const redirSignatureString = `${stringToSign}:completion_type=${completionValue}:transaction_id=${transaction_id}`;
			const redirEncodedString = encodeURI(redirSignatureString);
			const redirSignature = createHash('sha256').update(redirEncodedString).digest('base64').replaceAll("=", "").replaceAll("+", "-").replaceAll("/", "_");

			const errSignatureString = `${stringToSign}:completion_type=${errValue}:transaction_id=${transaction_id}`;
			const errEncodedString = encodeURI(errSignatureString);
			const errSignature = createHash('sha256').update(errEncodedString).digest('base64').replaceAll("=", "").replaceAll("+", "-").replaceAll("/", "_");

			const dqSignatureString = `${stringToSign}:completion_type=${dqValue}:transaction_id=${transaction_id}`;
			const dqEncodedString = encodeURI(dqSignatureString);
			const dqSignature = createHash('sha256').update(dqEncodedString).digest('base64').replaceAll("=", "").replaceAll("+", "-").replaceAll("/", "_");

			const oqSignatureString = `${stringToSign}:completion_type=${oqValue}:transaction_id=${transaction_id}`;
			const oqEncodedString = encodeURI(oqSignatureString);
			const oqSignature = createHash('sha256').update(oqEncodedString).digest('base64').replaceAll("=", "").replaceAll("+", "-").replaceAll("/", "_");

			params.redir = params.redir ? params.redir.replace(regex, transaction_id) + `&apik=${apik}&byk=${byk}&signature=${redirSignature}` : null;
			params.err = params.err ? params.err.replace(regex, transaction_id) + `&apik=${apik}&byk=${byk}&signature=${errSignature}` : null;
			params.dq = params.dq ? params.dq.replace(regex, transaction_id) + `&apik=${apik}&byk=${byk}&signature=${dqSignature}` : null;
			params.oq = params.oq ? params.oq.replace(regex, transaction_id) + `&apik=${apik}&byk=${byk}&signature=${oqSignature}` : null;
			params.partner = 'Prodege';
			
			/*	Sample link to test encoding

				https://api.prodegepeeq.com/prodegemr/transaction-completion
				?secret_key=abcdef123456
				&apik=APIK+SECRET+KEY
				&byk=PYK+SECRET+KEY
				&completion_type=1
				&transaction_id=123456789
				&signature=SIGNATURE+STRING+FROM+CREATEDHASH ('signature' is the result of encoding the parameters above)
			*/
			return params;
		}
		default: {
			/* EXAMPLE DEFAULT LINK

			https://portal.pilot.ly/process-target?
			gid=798789543486786754344357
			&redir=https%3A%2F%2Fsurvey.saysoforgood.com%2Fresult%3Fresult%3DC%26sesskey%3Dresponseid
			&err=https%3A%2F%2Fsurvey.saysoforgood.com%2Fresult%3Fresult%3DT%26sesskey%3Dresponseid
			&oq=https%3A%2F%2Fsurvey.saysoforgood.com%2Fresult%3Fresult%3DQ%26sesskey%3Dresponseid
			&dq=https%3A%2F%2Fsurvey.saysoforgood.com%2Fresult%3Fresult%3DS%26sesskey%3Dresponseid
			&sec=1
			&partner=ResearchForGood
			&partnerid={sesskey}
			
			*/

			setPersistentValue(PARTNER_KEY, "partnerid", 1, true);
			setPersistentValue(PARTNER_ID, partnerid, 1, true);

			params.redir = params.redir ? params.redir.replace(regex, partnerid) : null;
			params.err = params.err ? params.err.replace(regex, partnerid) : null;
			params.dq = params.dq ? params.dq.replace(regex, partnerid) : null;
			params.oq = params.oq ? params.oq.replace(regex, partnerid) : null;

			Logger.log("targetProcess.js", 'partnerIdReplace() regex', params);

			return params;
		}

	}
};

export const publisherReplace = (params) => {
	if (params.publisher) {
		params.publisher = params.publisher.replace("_", " ");
	}
	return params;
};

export const createFakeUser = (params, fakeUserDemographics) => {
	let user = {};
	let sampleSource = params.partner; //example 
	if (params.rch === '1') sampleSource = "ReelChat";

	// create fake user if study is using a partner provider
	if (params.partner && !params.dl && !params.rch) {
		user['email'] = getFakeEmail(params);
		user['password'] = sampleSource + 'password';
		user['fullname'] = params.name ? params.name : sampleSource + ' USER';
		user['firstname'] = params.firstname ? params.firstname : sampleSource;
		user['lastname'] = params.lastname ? params.lastname : 'User';
		user['age'] = isValidAge(params.age) ? params.age : null;
		user['gender'] = formatGender(params.gender) ? formatGender(params.gender) : null;
		user['zipcode'] = params.zipcode ? params.zipcode : null;

		// create fake user if study is using a distribution list
	}
	else if (!params.partner && !params.rch && params.dl) {
		user.email = getFakeEmail(params); // provided email in the dist url

		user.password = btoa(user.email); // using the provided email as the password
		user.password = user.password.replace('==', '');
		user.fullname = 'distributionUser';
		user.firstname = 'User';
		user.lastname = 'AutoRegistered';
	}
	else if (!params.partner && params.client === "1" && params.test === "1") {
		user.email = getFakeEmail(params);
		user.password = btoa(user.email); // using the provided email as the password
		user.password = user.password.replace('==', '');
		user.fullname = 'ClientTestUser AutoRegistered';
		user.firstname = 'ClientTestUser';
		user.lastname = 'AutoRegistered';
	}
	else if (!params.partner && params.rch === '1') {
		user.email = getFakeEmail(params);
		user.password = sampleSource + 'password';
	}

	if (fakeUserDemographics) {
		const genders = ["m", "f"].sort(() => 0.5 - Math.random());
		user.gender = genders[0];
		user.age = Math.floor(Math.random() * (70 - 13) + 13); // min age: 13, max age: 70
		user.hhi = Math.floor(Math.random() * (150000 - 25000) + 25000); // min hhi: 25000, max hhi: 150000
		user.zipcode = "NA";
	}

	return user;
};

export const getFakeEmail = (params) => {
	/*
      Here we check to see what partner we are dealing with and after
      we create a fake email using the gid + the name of the partner
      we then check to see if the email is already in the db
	*/

	let fakeEmail = "";
	let partnerUserId = "";
	const groupId = params.gid;
	if (params.partner) {
		let partnerid = params.partnerid_param && params[params.partnerid_param]
			? params[params.partnerid_param]
			: params.pil_partnerid || params.pil_partner_id || params.partnerid || params.partner_id;
		
		switch (params.partner.toLowerCase()) {
			case 'toluna': {
				let tolunaid = params.tolunaid;
				if (!tolunaid && partnerid) {
					tolunaid = partnerid;
				}
				fakeEmail = `${groupId + '.' + tolunaid}@tx-pilot.ly`;
				break;
			}
			case 'gmi': {
				fakeEmail = `${params.unique_id}@gmi-pilot.ly`;
				break;
			}
			case 'researchnow': {
				let rnowid = params.rnowid;
				if (!rnowid && partnerid) {
					rnowid = partnerid;
				}
				fakeEmail = `${groupId + '.' + rnowid}@rnow-pilot.ly`;
				break;
			}
			case 'fuelcycle': {
				partnerUserId = params.fcUserId ? params.fcUserId.toLowerCase() : "";
				fakeEmail = `${groupId + '.' + partnerUserId}@fuelcyclestage-pilot.ly`;
				break;
			}
			case 'purespectrum':
			case 'prodege': {
				let transaction_id = params.old_transaction_id ? params.old_transaction_id : params.transaction_id;
				const domain = params.partner === 'PureSpectrum'
					? '@purespectrum-pilot.ly'
					: '@prodege-pilot.ly';
				if (!transaction_id && partnerid) {
					transaction_id = partnerid;
				}
				partnerUserId = transaction_id ? transaction_id : "";
				fakeEmail = `${groupId + '.' + partnerUserId}${domain}`;
				break;
			}
			case 'material': {
				/*
					Keeping (`${params['I.Engine']}-${params['I.Session']}`;) as a reference
					In case we need to double back and update the email_id to include one of these param values
				*/
				let email_id = params.partnerid; //`${params['I.Engine']}-${params['I.Session']}`; 
				fakeEmail = `${groupId + '.' + email_id}@material-pilot.ly`;
				break;
			}
			case 'alida': {
				let email_id = `${params['MemberId']}.${params['CommunicationId']}`;
				fakeEmail = `${groupId + '.' + email_id}@alida-pilot.ly`;
				break;
			}
			case 'qualtrics': {
				let email_id = params.memberId;
				if (!email_id && partnerid) {
					email_id = partnerid;
				}
				fakeEmail = `${groupId + '.' + email_id}@qualtrics-pilot.ly`;
				break;
			}
			default: {
				let partnerDisplay = params.partner ? params.partner.toLowerCase() : "";
				fakeEmail = `${groupId + '.' + params.partnerid}@${partnerDisplay}-pilot.ly`;
			}
		}
	}
	else if (params.dl) {
		let regex = new RegExp(/@.*/, 'g');
		let useridParam = params.email ? params.email.replace(regex, '') + "." + params.dl : null;
		Logger.log('secured Pilotly Distrib unique ID ' + useridParam);
		fakeEmail = useridParam + '@distrib-pilot.ly';
	}
	else if (params.client) {
		let partnerDisplay = "client-test";
		let partnerid = helpers.randomString(24);
		Logger.log('Pilotly client test unique ID: ' + groupId + '.' + partnerid);
		fakeEmail = `${groupId + '.' + partnerid}@${partnerDisplay}-pilot.ly`;
	}
	else if (params.rch === '1') {
		fakeEmail = `${groupId}.${REELCHAT_USERNAME}@reelchat-pilot.ly`;
	}


	return fakeEmail;
};

export const parseUrl = (url) => {
	const params = helpers.getParamsFromUrl(url);

	if (params.dl) {
		params['provider'] = 'distribution-list';
	}
	else if (params.partner) {
		params['provider'] = params.partner;

		if (params.partner === "nrg" && params.redir) {
			const redirectUrlParams = helpers.getParamsFromUrl(decodeURIComponent(params.redir));
			params['partnerid'] = params['sid'] ? params['sid'] : params['partnerid'];
			params['age'] = isValidAge(params['a']) ? params['a'] : undefined;
			params['gender'] = formatGender(params['g']) ? formatGender(params['g']) : undefined;
			params['zipcode'] = params['z'];
			params['answer_index'] = isNumber(params['q3']) ? Number(params['q3']) - 1 : '';
		}
	}
	else {
		params['provider'] = 'pilotly-user';
	}

	if (params.name) {
		params.name = decodeURIComponent(params.name);

		let userName = params.name.split(' ');
		params.firstname = userName[0] ? userName[0] : 'Pilotly';
		params.lastname = userName[1] ? userName[1] : 'User';
	}
	return params;
};

export const validateParams = (params) => {
	if (!params) return false;
	let errors = {};

	if (!params.gid) {
		errors['reason'] = "Missing Group ID";
	}

	if (params.partner) {
		if (!params.dq && !params.oq) {
			errors['reason'] = "Invalid url. Does not contain over quota or data quality redirect.";

		}
		if (!params.redir) {
			errors['reason'] = "Invalid url. Does not contain complete redirect.";

		}
		if (!params.err) {
			errors['reason'] = "Invalid url. Does not contain terminate redirect.";
		}

		switch (params.partner.toLowerCase()) {
			case 'toluna': {
				if (!params.tolunaid) {
					errors['reason'] = "Missing Toluna ID";
				}
				break;
			}
			case 'gmi': {
				if (!params.unique_id) {
					errors['reason'] = "Missing Unique ID";
				}
				break;
			}
			case 'purespectrum': {
				if (!params.transaction_id) {
					errors['reason'] = "Missing Transaction ID";
				}
				break;
			}
			case 'researchnow': {
				if (!params.rnowid) {
					errors['reason'] = "Missing Research Now ID";
				}
				break;
			}
			case 'fuelcycle': {
				if (!params.fcUserId || !params.fcTrackId) {
					errors['reason'] = !params.fcUserId ? "Missing FC User ID" : "Missing FC Track ID";
				}
				if (!params.redirectUrl) {
					errors['reason'] = "Invalid url. Missing redirect link";
				}
				break;
			}
		}
	}

	if (!params.partner && (params.dq || params.oq || params.err || params.tolunaid || params.unique_id || params.transaction_id || params.rnowid || params.fcUserId || params.fcTrackId)) {
		errors['reason'] = "Missing Partner Info";
	}

	// if (params.email !== 'demo' && !params.dl) {
	// 	errors['reason'] = "Missing Distribution List ID";
	// }

	if (params.dl && !params.email) {
		errors['reason'] = "Missing forwarding email address";
	}

	if (params.dl && !params.publisher) {
		errors['reason'] = "Missing Publisher Info";
	}

	if ((params.dl || params.partner) && !params.fakeUser) {
		errors['reason'] = "Did not create user info.";
	}

	// if (!params.dl && (params.publisher || params.email)) {
	// 	errors['reason'] = "Missing Distribution List ID";
	// }
	return Object.keys(errors).length ? errors : false;
};

export const decodeRedirects = (params) => {
	if (params.redir) params.redir = decodeURIComponent(params.redir);
	if (params.err) params.err = decodeURIComponent(params.err);
	if (params.oq) params.oq = decodeURIComponent(params.oq);
	if (params.dq) params.dq = decodeURIComponent(params.dq);
	return params;
};

export const isThirdPartyUser = (params) => {
	if (!params) return false;
	let userEmail = params.email;
	let thirdPartyDomains = ["tx-pilot.ly", "gmi-pilot.ly", "rnow-pilot.ly", "fuelcyclestage-pilot.ly", "purespectrum-pilot.ly"];

	for (let i = 0; i < thirdPartyDomains.length; i++) {
		let emailDomain = thirdPartyDomains[i];
		if (userEmail.includes(emailDomain)) return true;
	}
	return false;
};

export const identifyPartnerFromUrl = (url) => {
	if (!url) return null;

	let urlParams = parseUrl(url);
	return urlParams.partner;
};

export const isSkippingIntro = (params) => {
	return params && params.intro && parseInt(params.intro) === 0;
};

export const isAlida = (params) => {
	return params.partner === "alida";
};

export const isPlayerBasic = (params) => {
	return params.vo === "1";
};

const hashPureSpectrumPartnerUrl = (url) => {
	Logger.log('targertProcess.js', 'hashPureSpectrumPartnerUrl()', url);

	const sharedsecret = "UK2RdT39zGfdK8rc";

	if (!url) {
		return url;
	}

	const decodedUrl = decodeURIComponent(url);

	let shasum = crypto.createHash('sha1');
	shasum.update(decodedUrl + sharedsecret);

	let hash = shasum.digest('hex');
	hash = hash.replace(/-/g, "").toLowerCase();

	const hashedUrl = decodedUrl + "&ps_hash=" + hash;

	Logger.log('targertProcess.js', 'hashPureSpectrumPartnerUrl() hashedUrl', hashedUrl);

	return hashedUrl;
};



// WEBPACK FOOTER //
// ./src/functions/targetProcess.js